document.addEventListener('DOMContentLoaded', function() {
  var wrapper = document.querySelector('#shopify-section-mini-cart');
  if (!wrapper) return;

  function swapAcaLinks(root) {
    root.querySelectorAll('a.aca-cco').forEach(function(oldLink) {
      var qty = oldLink.getAttribute('aca-quantity');
      var lineItemQty = oldLink.closest('line-item-quantity');
      if (!lineItemQty) return;

      var input = lineItemQty.querySelector('input.quantity-selector__input');
      if (!input) return;
      var match = input.name.match(/\[([^\]]+)\]/);
      if (!match) return;
      var idKey = match[1];

      // build the new <a>
      var a = document.createElement('a');
      a.href = '/cart/change?quantity=' + qty + '&id=' + encodeURIComponent(idKey);

      if (oldLink.classList.contains('line-item__remove-button')) {
        // === Restore the "Remove" link classes ===
        oldLink.classList.forEach(function(cls) {
          if (cls !== 'aca-cco') a.classList.add(cls);
        });
        // copy any data-no-instant or aria-label if present
        if (oldLink.hasAttribute('data-no-instant')) {
          a.setAttribute('data-no-instant', oldLink.getAttribute('data-no-instant'));
        }
        if (oldLink.hasAttribute('aria-label')) {
          a.setAttribute('aria-label', oldLink.getAttribute('aria-label'));
        }
        a.textContent = oldLink.textContent.trim();
      } else {
        // === It's a + or - button, make it a quantity button ===
        a.className = 'quantity-selector__button';
        a.setAttribute('aria-label', oldLink.getAttribute('aria-label') || '');
        a.innerHTML = oldLink.innerHTML; 
      }

      oldLink.replaceWith(a);
    });
  }

  // initial pass
  swapAcaLinks(wrapper);

  // watch for every re-render under the section
  new MutationObserver(function() {
    swapAcaLinks(wrapper);
  }).observe(wrapper, { childList: true, subtree: true });
});
